import { SubmissionStatusPresenter } from '@/presentation/presenters/dashboard/submissionStatusPresenter'
import { SubmissionStatusViewModel } from '@/presentation/viewmodels/dashboard/submissionStatusViewModel'

export function useSubmissionStatusPresenter(
  presenter: SubmissionStatusPresenter = new SubmissionStatusPresenter(new SubmissionStatusViewModel())
) {
  return {
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    hasData: presenter.hasData,
    initChart: presenter.initChart.bind(presenter)
  }
}
